<template>
  <div :style="`width: 100%; height:${height}px`" :class="[{'is_disabled':disabled},'editor']">
    <quill-editor
      :id="randomId(3)"
      :ref="myEditor"
      v-model="content"
      :options="options"
      style="width: 100%; height: 100%"
      @change="onChange($event)"
    />
    <el-upload
      :key="randomId(3)"
      ref="upload"
      class="upload_col"
      :auto-upload="false"
      :accept="accept"
      action=""
      multiple
      :before-upload="beforeUpload"
      :data="myHeaders"
      :on-change="fileAdd"
    />
  </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor, Quill } from 'vue-quill-editor'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/ImageResize', ImageResize)
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
const revokeImg = require('@/assets/common/revoke.png')
const restoreImg = require('@/assets/common/restore.png')
/**
 * 富文本
 * content 内容
 * options 参数配置
 * 官网文档地址 https://www.kancloud.cn/liuwave/quill/1409423
 *
*/
// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
  ['blockquote', 'code-block'], // 引用  代码块
  [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
  [{ indent: '-1' }, { indent: '+1' }], // 缩进
  [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ align: [] }], // 对齐方式
  ['clean'], // 清除文本格式
  ['link', 'image'], // 链接、图片、视频'video'
  ['revoke', 'restore'] // 撤销 恢复
]
export default {
  components: {
    quillEditor
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: {
      type: String
    },
    /* 编辑器的索引 */
    quillIndex: {
      type: Number,
      default: 0
    },
    /* 编辑器的唯一标识符 */
    myEditor: {
      type: String,
      default: 'quillEditor'
    },
    fileSize: {
      type: Number,
      default: 5
    },
    height: {
      type: Number,
      default: 300
    },
    // 上传图片方法
    upload: { type: Function, default: Function },
    isDel: {type:Boolean,default: false},
    // 删除附件
    del: { type: Function, default: Function },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      accept: 'image/*', // 接收类型
      imageTypes: ['jpg', 'jpeg', 'png', 'gif'], // 图片类型
      maxFileLen: 0, // 最大文件长度
      content: this.value, // 富文本内容
      history: [], // 历史
      // quill-editor 配置
      options: {
        theme: 'snow', // or 'bubble'
        placeholder: '请输入内容',
        readyOnly: this.disabled,
        modules: {
          imageDrop: true, // 拖动加载图片组件
          ImageResize: {
            parchment: Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          },
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  document.querySelectorAll('.upload_col input')[this.quillIndex].click()
                } else {
                  this.quill.format('image', false)
                }
              },
              revoke: () => {
                if (this.history.length > 1) {
                  let history = this.history.pop()
                  history = this.history.pop()
                  this.content = history
                }
                this.hintState()
              },
              restore: () => {
                const history = this.history[0]
                this.history = []
                this.content = history
                this.hintState()
              }
            }
          }
        },
        // 自定义按钮
        initButton: () => {
          const revokeButton = document.querySelector('.ql-revoke')
          revokeButton.style.cssText = 'width:28px;height:24px;padding:2px 4px'
          revokeButton.setAttribute('alt', '撤销')
          revokeButton.innerHTML = '<img style="width:18.4px;height:18.4px" src="' + revokeImg + '" />'

          const restoreButton = document.querySelector('.ql-restore')
          restoreButton.style.cssText = 'width:28px;height:24px;padding:2px 4px'
          restoreButton.setAttribute('alt', '恢复')
          restoreButton.innerHTML = '<img style="width:18.4px;height:18.4px" src="' + restoreImg + '" />'
        }
      },
      myHeaders: { token: localStorage.getItem('token') },
      imageList: [] // 图片src集合
    }
  },
  computed: {
    editor() {
      return this.$refs[this.myEditor].quillEditor
    }
  },
  watch: {
    value: function() {
      // this.content = this.value
      this.content = this.escapeStringHTML(this.value)
      if (this.value === '') {
        this.history.push('')
        this.imageList = []
      }
    }
  },
  mounted() {
    this.options.initButton && this.options.initButton()
    if (this.disabled) {
      this.$refs[this.myEditor].quill.blur()
      this.$refs[this.myEditor].quill.enable(false)
    } else this.hintState()
    const dom = this.$refs[this.myEditor].$el.querySelector('.ql-container')
    dom.style.height = (this.height - this.$refs[this.myEditor].$el.querySelector('.ql-toolbar').offsetHeight) + 'px'
  },
  methods: {
    /**
     * @description  编辑器状态
    */
    hintState() {
      this.$nextTick(function() {
        this.$refs[this.myEditor].quill.enable(true)
        this.$refs[this.myEditor].quill.blur()
      })
    },
    /**
     * @param {len}   长度：number类型
     * @description 随机生成quill-editor的id，与上传的key值
     * @author tan 2022/3/14
    */
    randomId(len) {
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var tempLen = chars.length; var tempStr = ''
      for (var i = 0; i < len; ++i) {
        tempStr += chars.charAt(Math.floor(Math.random() * tempLen))
      }
      return tempStr
    },
    /**
     * @param {fileobj} 文件对象
     * @param {fileList} 文件数组
     * @description 图片单个或者批量按照顺序上传
     * @author tan 2022/3/14
    */
    fileAdd(fileobj, fileList) {
      const currLength = fileList.length
      this.maxFileLen = Math.max(currLength, this.maxFileLen)
      if (currLength !== this.maxFileLen) return
      this.maxFileLen = 0
      this.imageList = []
      this.$refs.upload.clearFiles() // 清空后才能再次调用上传
      const file = fileobj.raw
      this.fileUpload(file)
    },
    /**
     * @param {file} 文件
     * @param {fileList} 文件集合
     * @description 上传文件
     * @author tan 2022/3/14
    */
    fileUpload(file, fileLists) {
      const that = this
      const callback = (res) => {
        const quill = that.$refs[that.myEditor].quill
        const length = quill.getSelection().index
        // 回显插入富文本编辑器
        quill.insertEmbed(length, 'image', res.url)
        quill.setSelection(length + 1) // 定位索引
        that.getDom(res)
        if (fileLists && fileLists.length !== 0) {
          var fileList = fileLists.reverse()
          fileList.forEach(item => {
            // 回显插入富文本编辑器
            quill.insertEmbed(length, 'image', item)
            quill.setSelection(length + 1) // 定位索引
          })
        }
      }
      that.upload(file, callback)
    },
    /**
     *@param {res} 对象
     *@description 给图片添加id属性
    */
    getDom(res) {
      const that = this
      const e = that.$refs.editor.$el.querySelector('.ql-editor')
      const images = e.querySelectorAll('img')
      if (images && images.length !== 0) {
        for (var i = 0; i < images.length - 1; i++) {
          if (images[i].src === res.url) {
            images[i].id = res.id
          }
        }
      }
    },
    /**
     * @param {file} 上传的文件
     * @description 上传前文件的判定大小
     * @author tan 2022/3/14
    */
    beforeUpload(file) {
      const isLt = file.size / 1024 / 1024 < this.fileSize
      if (!isLt) {
        this.$message({
          message: `图片单张不得超过${this.fileSize}M，请重新选择！`,
          type: 'error'
        })
      }
      return isLt
    },
    /**
     * @param {html} 修改的内容
     * @description 富文本内容改变
     * @author tan 2022/3/14
    */
    onChange({ html }) {
      const that = this
      const imgReg = /<img.*?(?:>|\/>)/gi
      const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
      const arr = html.match(imgReg)
      const imageList = []
      if (arr && arr.length !== 0) {
        for (var i = 0; i < arr.length; i++) {
          var src = arr[i].match(srcReg)
          if (src[1]) imageList.push(src[1])
        }
      }
      that.imageList = imageList
      if (that.value !== html) {
        if (that.isDel && ((that.value && that.value.length > html.length) || !that.value || !html)) that.del(!that.imageList || !that.imageList.length ? void 0 : that.imageList)
      }
      that.history.push(html)
      that.$emit('input', that.content)
    },
    /**
     * @param {str} 文本内容
     * @description 格式化文本内容
     * @returns 文本内容
     * @author tan 2022/3/16
    */
    escapeStringHTML(str) {
      if (!str) return ''
      str = str.replace(/&lt;/g, '<')
      str = str.replace(/&gt;/g, '>')
      return str
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/variables.scss";
$editorHeight:50px;
.upload_col {
  height: 0;
  width: 0;
  overflow: hidden;
}
.editor{
  .ql-editor{
      min-height: 300px;
  }
}
.is_disabled{
  background: #f1f1f1;
  cursor: not-allowed;
}

</style>
